import { render, staticRenderFns } from "./NewsDialog.vue?vue&type=template&id=07f755a9&scoped=true&"
import script from "./NewsDialog.vue?vue&type=script&lang=js&"
export * from "./NewsDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewsDialog.vue?vue&type=style&index=0&id=07f755a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f755a9",
  null
  
)

export default component.exports